export default {
  snapshotRecordGetter: state => state.snapshotsRecords,
  totalItemsGetter: state => state.totalItems,
};
